<template lang="pug">
div.imagen-completa
  div.loyalty-cupon-img
    h1.loyalty-cupon-img__title {{ $t('loyalty.preview') }}
  div.cuadro-principal
    div
      div(v-if="data.imagen")
        ods-image(v-bind:src="'data:image/png;base64,' +imagen" fit='fill').imagen
      div(v-else).centerImg
        ods-image(:src="require('@/assets/icons/ticket.svg')" fit='fill').imagenNotFound
      div.cuadro-principal__texto
        h1.loyalty-cupon-img__title1 {{ data.descripcion }}
        h2.loyalty-cupon-img__title2 {{ data.des_client }}
        h2.loyalty-cupon-img__title3 {{ data.subtitulo }}
        h2.loyalty-cupon-img__title4 {{ data.ptos_fijo }} {{ $t('loyalty.points').toLowerCase() }}
        h2(v-if="data.fechaici.valueDate && data.fechafin.valueDate").loyalty-cupon-img__title5 {{ $t('loyalty.valid') }} {{ $t('loyalty.sincede').toLowerCase() }} {{data.fechaici | formatDateLocale}} {{ $t('loyalty.untilde').toLowerCase() }} {{data.fechafin | formatDateLocale}}
        h2(v-else).loyalty-cupon-img__title5 {{ $t('loyalty.noData') }}
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    },
    imagen: {
      type: String
    }
  },
  name: 'ImagenCupon'
}
</script>
<style lang="scss">
.loyalty-cupon-img{
  .ods-module__body{
      padding: 0;
  }
    &__title{
    font-size: rem(14);
    line-height: rem(24);
    margin-bottom: rem(16);
    margin-left: rem(32);
    margin-right: rem(32);
    margin-top: rem(32);
    font-weight: 500;
  }
    &__title1{
    margin-top: rem(24);
    margin-left: rem(24);
    margin-right: rem(24);
    font-size: rem(16);
    line-height: rem(24);
    letter-spacing: rem(0);
    margin-bottom: rem(8);
    font-weight: 500;
    text-align: left;
  }
    &__title2{
    margin-left: rem(24);
    margin-right: rem(24);
    font-size: rem(11);
    line-height: rem(16);
    letter-spacing: rem(0);
    margin-bottom: rem(17);
    text-align: left;
    color: #6E767D;
  }
    &__title3{
    margin-left: rem(24);
    margin-right: rem(24);
    font-size: rem(12);
    line-height: rem(20);
    letter-spacing: rem(0);
    margin-bottom: rem(8);
    font-weight: 500;
    text-align: left;
    color: #060E14;
  }
    &__title4{
    margin-left: rem(24);
    margin-right: rem(24);
    font-size: rem(11);
    line-height: rem(16);
    letter-spacing: rem(0);
    margin-bottom: rem(8);
    text-align: left;
    color: #6E767D;
  }
    &__title5{
    margin-left: rem(24);
    margin-right: rem(24);
    font-size: rem(11);
    line-height: rem(16);
    letter-spacing: rem(0);
    margin-bottom: rem(24);
    text-align: left;
    color: #6E767D;
  }
}

.cuadro-principal{
    align-content: center;
    border-top-width: rem(2);
    margin-left: rem(32);
    margin-right: rem(32);
    &__texto{
    border: 1px solid #A2ACB3;
    background-color: #FFFFFF;
  }
}
.imagenNotFound {
  width: 50%;
  height: 50%;
}
.centerImg {
  background-color: #FFFFFF;
  text-align: center;
}
.imagen{
  width: 100%;
  height: 100%;
}
.imagen-completa{
  background: #F9F9FB;;
}
 .ods-dialog__body{
   img{
     width: 100%;
   }
 }
</style>
